import { CHARACTER_FAVORITE_LIMIT } from "@/constants";

import { getFormattedMessage } from "./getFormattedMessage";

export const showMaxFavoriteCharacterError = ({ errorData, setErrorModalMessage, setErrorModalVisible, setLiked }) => {
  if (!errorData) return;
  const { errorCode, errorExtras } = errorData;
  if (errorCode === CHARACTER_FAVORITE_LIMIT.code && errorExtras?.character_favorite_limit) {
    const formattedMessage = getFormattedMessage({ ...errorExtras }, CHARACTER_FAVORITE_LIMIT.message);
    setErrorModalMessage(formattedMessage);
    setErrorModalVisible(true);
    setLiked(false);
  }
};
